module.exports = __webpack_public_path__ + "img/ic_64_achievement_spitzenreiter.43a7c486.svg";